import { render, staticRenderFns } from "./PEAApprovalRolesAndRules.vue?vue&type=template&id=7a6efafc&scoped=true"
import script from "./PEAApprovalRolesAndRules.vue?vue&type=script&lang=js"
export * from "./PEAApprovalRolesAndRules.vue?vue&type=script&lang=js"
import style0 from "./PEAApprovalRolesAndRules.vue?vue&type=style&index=0&id=7a6efafc&prod&scoped=true&lang=css"
import style1 from "./PEAApprovalRolesAndRules.vue?vue&type=style&index=1&id=7a6efafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6efafc",
  null
  
)

export default component.exports